import { FiArrowRight, FiEye } from "react-icons/fi";
import { theme } from "src/styles/theme";
import { css, styled } from "styled-components";


interface HeaderProps{
    activateEdit?: boolean;
    onCancel:()=>void;
    onAction:()=>void;
    color?: string;
    showEdit?: boolean;
    type: 'edit' | 'respond' | 'review' | 'publish';
}
const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    //   padding: 20px 30px;
    z-index: 999999999999999;
    position: relative;

    width: 100%;

    padding: 10px 30px 0px 30px;

`;

const Logo = styled.h1<{color?: string}>`
    font-family: ${theme.fonts.secondary};
    font-weight: ${theme.fontWeights.bold};;
    font-size: ${theme.fontSizes.xxxxl};;
    line-height: 100%;
    letter-spacing: -2%;
    color: ${props=>props.color || "#FFFFFF"};
    @media (max-width: ${theme.breakpoints.mobile}px) {
    font-size: 14px;

    }
`;

const ActionButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 24px;
`;

const CancelButton = styled.button<{activate: boolean, color?: string}>`
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;

  font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.semiBold};;
    font-size: ${theme.fontSizes.base};;
    line-height: 135%;
    letter-spacing: 0%;

    background: transparent;
    color: ${props=>props.color || "#FFFFFF"};
    opacity: 0.5;

    ${props=>props.activate && css `
        opacity: 1;
    `};
`;

const EditButton = styled(CancelButton)`
    width: 119px;
    height: 39px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 50px;
    padding-top: 10px;
    padding-right: 20px;
    padding-bottom: 10px;
    padding-left: 20px;
    // background: var(--Grey-333333, #333333);
    background: #FFFFFF;
    opacity: 0.5;
    
    ${props=>props.activate && css `
        opacity: 1;
    `};

    &>span{
        color: #1A1A21;
        font-family: ${theme.fonts.primary};
        font-weight: ${theme.fontWeights.semiBold};;
        font-size: ${theme.fontSizes.base};;
        line-height: 135%;
        letter-spacing: 0%;
    }

`;

const PreviewContainer = styled.div`
    position: relative;
    width: 15%;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;

    @media (max-width: ${theme.breakpoints.mobile}px) {
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }
`;

const PreviewButton = styled.button`
    width: 105px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    border-radius: 40px;
    padding-top: 8px 16px;
    background: #FFFFFF66;


    &>span{
        font-family: ${theme.fonts.primary};
        font-weight: ${theme.fontWeights.semiBold};
        font-size: ${theme.fontSizes.md};
        line-height: 135%;
        letter-spacing: 0%;
    }
`

const HeaderComp: React.FC<HeaderProps> = ({activateEdit, showEdit, onCancel, onAction, type, color}) => {
    return (
        <Header>
            <Logo color={color}>Qcast Studio</Logo>
            {type ==='edit' && 
                <PreviewContainer>
                    <PreviewButton>
                        <span>Preview</span>
                        <FiEye />
                    </PreviewButton>
                </PreviewContainer>
            }
            {type ==='respond' && 
                <ActionButtons>
                    <CancelButton activate={activateEdit} onClick={onCancel}>Cancel</CancelButton>
                    {showEdit &&
                        <EditButton activate={activateEdit} onClick={onAction}>
                            <span>Edit</span>
                            <FiArrowRight size={16} color={"#333333"} style={{fontWeight: "bold"}} />
                        </EditButton>
                    }
                    
                </ActionButtons>
            }
            {type ==='edit' && 
                <ActionButtons>
                    {/* <CancelButton activate={true} onClick={onCancel} color={color}>Save as Draft</CancelButton> */}
                    <EditButton activate={true} onClick={onAction} style={{background: "var(--Abyss, #190F49)", color: "#FFFFFF"}}>
                        <span style={{color: "#FFFFFF"}}>Review</span>
                        <FiArrowRight size={20} color={"#FFFFFF"} style={{fontWeight: "bold"}} />
                    </EditButton>
                </ActionButtons>
            }

            {type ==='review' && 
                <ActionButtons>
                    {/* <CancelButton activate={true} onClick={onCancel} color={color}>Save as Draft</CancelButton> */}
                    <EditButton activate={true} onClick={onAction} style={{background: "var(--Abyss, #190F49)", color: "#FFFFFF"}}>
                        <span style={{color: "#FFFFFF"}}>Publish</span>
                        <FiArrowRight size={20} color={"#FFFFFF"} style={{fontWeight: "bold"}} />
                    </EditButton>
                </ActionButtons>
            }
        </Header>
    )
}

export default HeaderComp;